export function getThemedField(provider, field, isDark) {
  const darkField = `${field}`.replace('Hex', 'DarkHex');
  if (isDark && provider[darkField]) {
    return `#${provider[darkField]}`;
  }

  if (!provider[field]) return null;
  return `#${provider[field]}`;
}
